import get from "lodash/get";
import type { Action } from "../../actions/types";
import { ShopifyDiscountRecord } from "./shopifyActiveDiscounts";

export type StoreState = {
  count: number;
  records: ShopifyDiscountRecord[];
};

export const initialState = {
  count: 0,
  records: [],
};

export function reducer(
  state: StoreState = initialState,
  action: Action
): StoreState {
  switch (action.type) {
    case "GET_SHOPIFY_ACTIVE_GIFT_CARDS_SUCCESS":
      return action.response.data;

    case "ACCOUNT_CREDIT_REVERSE_SUCCESS": {
      const transactionId = get(
        action.response,
        "data.reversed.original.record.id"
      );

      const indexOfExistingReward = state.records.findIndex(
        (record) => record.id === transactionId
      );
      const updatedRecords = [...state.records];

      if (indexOfExistingReward > -1) {
        updatedRecords.splice(indexOfExistingReward, 1);
      }

      return { ...state, records: updatedRecords, count: state.count - 1 };
    }

    default:
      return state;
  }
}
